export default "__VITE_ASSET__BjXzHx5X__"